import { ParameterByAttribute } from "../../../interfaces/style";

const ENDING_MULTIPLIER = 4;

export const valuesEndingMultiplier = (
  symbol: ParameterByAttribute<number>,
  multiplier = ENDING_MULTIPLIER,
): ParameterByAttribute<number> => {
  return {
    ...symbol,
    defaultValue: symbol.defaultValue * multiplier,
    values: symbol.values.map(item => ({ ...item, value: item.value * multiplier })),
  };
};
